<template>

	<div class="main">
		<div class="ewm">
			<img src="../assets/ewm.jpg" style="height:100px;width:100px;" />
			<div class="text">
				微信扫码使用小程序
			</div>
		</div>
		<div class="log401" v-if="iskf">
			<div class="car401">
				<div class="log-title">
					<span class="tishi1">你没有登录，会话消息容易丢失！</span>
				</div>
				<div class="log-title">
					<el-button type="primary" @click="ischat=true;iskf=false">继续</el-button>
					<el-button type="warning" @click="iskf=false">放弃</el-button>
				</div>
			</div>
		</div>

		<div class="chat-main" v-if="ischat">
			<Gchat @close="ischat=false" :target="currentChatTarget">
			</Gchat>
		</div>

		<Sedituser v-if="isedit" @close="isedit=false"></Sedituser>


		<div class="zhezhao" v-if="iszhezhao">
			<Ssign v-if="issign" @close="issign = false;iszhezhao = false;">
			</Ssign>
			<Slogin v-if="islogin" @close="
          islogin = false;
          iszhezhao = false;
        "></Slogin>
		</div>
		<div class="logo">
			<img src="../assets/1.png" class="menu-img" />
			<div class="logo-text">易淞在线</div>
		</div>

		<div class="menu">
			<div class="menu-list" @click="main()">首页</div>
			<div class="menu-list" @click="zlqd()" :class="{ 'menu-list1': nub == 1 }">
				委托编制
			</div>
			<div class="menu-list" v-if="Susername" @click="me()" :class="{ 'menu-list1': nub == 2 }">
				我的项目
			</div>
			<div class="logoname" @mouseenter="cancelMsgCloseTimer" @mouseleave="startMsgCloseTimer">

				<div class="longbut0" @click="toggleMessageDropdown">
					<span v-if="Susername">我的</span>消息
					<span class="unread-dot" v-if="isnewchat"></span>

				</div>
				<div class="message-dropdown" v-if="showMessageDropdown">
					<div class="message-header">
						<span>消息列表</span>
						<button class="read-all" @click="markAllAsRead">全部标为已读</button>
					</div>

					<div class="message-list">
						<div class="message-item" v-for="(msg, index) in SmockMessages" :key="index"
							@click="openChat(msg)" v-if="SmockMessages.length>0">
							<div class="msg-avatar" :class="{'msg-avatar1':msg.unread}">{{ msg.type.name[0] || '未' }}

							</div>
							<div class="msg-content">
								<div class="msg-sender" :title="msg.type.name">{{ msg.type.name }}</div>
							</div>

						</div>

						<div class="empty-message" v-else>
							暂无消息
						</div>
					</div>
				</div>
			</div>
			<div class="menu-but" v-if="!Susername">
				<div class="list-but">
					<span class="sp" @click="runlogin">登录</span><span>/</span><span class="sp"
						@click="runsign">注册</span>
				</div>
			</div>
			<div v-if="Susername" class="logoname" @mouseenter="cancelCloseTimer" @mouseleave="startCloseTimer($event)"
				ref="logonameRef">
				<div class="longbut1">{{ Susername}}</div>
				<div class="longbut2" @click.stop="islongtc">∨</div>
				<div class="long-tc" v-if="istanchu" @mouseenter="cancelCloseTimer"
					@mouseleave="startCloseTimer($event)">
					<div class="tc-content  st" @click="Sedituser()">
						<img src="../assets/edit.png" class="tc-img" />
						修改帐号
					</div>
					<div class="tc-content" @click="exitlogin">
						<img src="../assets/exit.png" class="tc-img" />
						退出帐号
					</div>
				</div>
			</div>
		</div>

		<router-view></router-view>
	</div>
</template>

<script>
	import Ssign from "./ez/Ssign.vue";
	import Slogin from "./ez/Slogin.vue";
	import Sedituser from "./ez/Sedituser.vue";
	// import messageHandler from '@/utils/websocketMessageHandler.js';

	import {
		Setitem,
		Getitem
	} from "@/utils/item";
	import {
		login,
		templogin,
		PROtype,

	} from "../utils/request.js";
	import Gchat from "./ez/Gchatgoing.vue";
	import {
		WSinit
	} from "@/utils/websocketMessageHandler.js";
	export default {
		data() {
			return {
				ws: null,
				currentChatTarget: {
					toid: '',
					toname: '',
					myname: '',
					myid: Getitem('userid'),
					toclass: ''
				},
				listname: '',
				newlist: [],
				nub: 0,
				iszhezhao: false,
				issign: false,
				islogin: false,
				Susername: this.$store.state.username,
				istanchu: false,
				closeTimer: null,
				is401: false,
				isedit: false,
				userid: Getitem('userid'),


				showMessageDropdown: false,
				msgCloseTimer: null,
				SmockMessages: [],
				isnewchat: false,
				tokenname: '',
				ischat: false,
				iskf: false
			};
		},
		methods: {



			// 消息下拉框控制方法
			toggleMessageDropdown() {
				this.showMessageDropdown = !this.showMessageDropdown;
				// 如果打开下拉框，同步最新消息
				if (this.showMessageDropdown) {
					this.syncMessages();
				}
			},

			startMsgCloseTimer() {
				this.msgCloseTimer = setTimeout(() => {
					this.showMessageDropdown = false;
				}, 300);
			},

			cancelMsgCloseTimer() {
				clearTimeout(this.msgCloseTimer);
			},

			// 标记全部已读
			markAllAsRead() {
				if (this.SmockMessages.length > 0) {
					this.SmockMessages.forEach(msg => {
						msg.unread = false;
					});
					Setitem(this.tokenname, this.SmockMessages)
					this.$store.commit("setnewchat", false);
				}
				this.isnewchat = false
			},

			// 从消息处理器同步消息
			async syncMessages() {
				// let listname = `${this.tokenname}_list`
				this.SmockMessages = await Getitem(this.listname) || []
				this.newChar()
			},


			Sedituser() {
				this.isedit = true
			},

			startCloseTimer(event) {
				// 延时检测，避免立刻关闭
				this.closeTimer = setTimeout(() => {
					if (!this.isInsideWithBuffer(event)) {
						this.istanchu = false;
					}
				}, 200); // 200ms 延时
			},
			cancelCloseTimer() {
				clearTimeout(this.closeTimer);
				this.closeTimer = null;
			},
			isInsideWithBuffer(e) {
				if (!this.$refs.logonameRef) return false;
				const rect = this.$refs.logonameRef.getBoundingClientRect();
				const buffer = 20; // 缓冲范围

				return (
					e.clientX >= rect.left - buffer &&
					e.clientX <= rect.right + buffer &&
					e.clientY >= rect.top - buffer &&
					e.clientY <= rect.bottom + buffer
				);
			},
			colosetc() {
				if (!this.istanchu) return
				clearTimeout(this.closeTimer);
				this.closeTimer = setTimeout(() => {
					this.istanchu = false
				}, 200);
			},
			async sinitWebSocket(userId, clientId) {

				if (userId) {
					// 清理旧连接（从Vuex获取实例）
					const oldWs = this.$store.state.mews;
					oldWs && await oldWs.close();

					// 初始化新连接
					await WSinit(clientId, userId);

					// 强制更新Vuex状态
					await this.$nextTick();
				} else {
					// console.warn("用户ID不存在，无法初始化WebSocket");
				}
			},

			async exitlogin() {
				this.is401 = false
				this.istanchu = false
				Setitem('user', "")
				Setitem('name', "")
				// this.$router.push("/login");
				this.$store.commit('setusername', '')


				let ss = await templogin()
				if (ss.code === 200) {
					let VuserId = ss.token
					let VclientId = 'cus'
					await this.sinitWebSocket(VuserId, VclientId)

					// window.location.reload()
					// if (this.$route.name !== 'zlqd' && this.$route.name !== 'main') {
					// 	this.$router.push("/main")
					// }

				}

			},
			islongtc() {
				this.istanchu = !this.istanchu
			},
			runlogin() {
				this.is401 = false
				this.iszhezhao = true;
				this.islogin = true;
			},
			runsign() {
				this.iszhezhao = true;
				this.issign = true;
			},

			zlqd() {
				this.nub = 1;
				this.$router.push("/zlqd");
			},
			main() {
				this.nub = -1;
				this.$router.push("/main");
			},
			me() {
				this.nub = 2;
				this.$router.push("/me");
			},
			log401() {
				this.is401 = true
			},


			async listmsg() {
				this.listname = `${this.tokenname}_list`
				this.SmockMessages = await Getitem(this.listname) || []
				this.newChar()

			},
			newChar() {
				let Smsglist = this.SmockMessages
				const unreadCount = Smsglist.filter(res => res.unread).length;
				this.isnewchat = unreadCount > 0;
			},
			openChat(msg) {
				let s = {
					toid: msg.toUser.split('_')[1],
					toname: msg.type.name || '未知',
					myname: this.Susername,
					myid: Getitem('userid'),
					toclass: msg.toUser.split('_')[0]
				}
				this.Sopenchat(s)
			},
			async Sopenchat(s) {
				let toUser = `${s.toclass}_${s.toid}`
				this.SmockMessages.forEach(res => {
					if (res.toUser === toUser) {
						res.unread = false
					}
				})
				await Setitem(this.listname, this.SmockMessages)
				this.newChar()
				this.currentChatTarget = s
				// console.log('这是传递给子组件的：', this.currentChatTarget);
				if (s.toid.length > 15) {
					this.iskf = true
				} else {
					this.ischat = true
				}
			},



		},
		async created() {
			this.$router.push("/main");
			this.ws = this.$store.state.mews
		},
		components: {
			Ssign,
			Slogin,
			Sedituser,
			Gchat

		},
		watch: {
			'$store.state.Slogin': {
				handler(newVal, oldVal) {
					if (newVal) {
						this.iszhezhao = true;
						this.islogin = true;

					}
					this.$store.commit('setSlogin', false)

				}
			},
			'$store.state.Stemp': {
				handler(newVal, oldVal) {
					if (newVal) {
						this.nub = -1;
						this.$router.push("/main");

					}
					this.$store.commit('setStemp', false)

				}
			},
			'$store.state.tokenName': {
				handler(newVal, oldVal) {

					this.tokenname = newVal
					// console.log('监听变化来没来', this.tokenname);
					this.listmsg()
				}
			},
			'$store.state.newchat': {
				deep: true, // 深度监听
				handler(newVal, oldVal) {
					this.syncMessages();
				}
			},
			'$store.state.username'(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.Susername = newVal;
					// 可以在这里添加登录状态变化后的其他逻辑
					if (newVal) {
						// console.log('用户已登录:', newVal);
					} else {
						// console.log('用户已退出');
					}
				}
			},
			'$store.state.log401'(newVal, oldVal) {
				if (newVal === '401') {
					this.is401 = true
				}
			},
			'$store.state.gochat'(newVal, oldVal) {
				// this.ischat = true
				if (newVal !== null) {
					this.Sopenchat(newVal)
				}


			},
		},
		beforeunload() {
			this.$store.commit('setSwindow', '')
		}


	};
</script>

<style lang="less" scoped>
	.main {
		width: 100vw;
		height: 100vh;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		// background-color: red;
		background-image: url("../assets/首页.jpeg");
		background-size: cover;
		background-position: center;
		overflow: hidden;
		/* 防止内容溢出视口 */
	}

	.logo {
		position: absolute;
		left: 1vw;
		top: -2px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 30px;
		font-weight: bold;
		color: #e5e5e5;
		height: 80px;
		line-height: 80px;

		.logo-text {
			padding-top: 20px;
			line-height: 80px;

		}

		.menu-img {
			width: 180px;
			height: 80px;
			margin-right: -20px;
		}
	}



	.menu {
		position: absolute;
		right: 4vw;
		top: 1vh;
		height: 6vh;

		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 45vw;



		.menu-list {
			font-size: 16px;
			color: #e5e5e5;
			font-weight: bold;
			display: flex;
			cursor: pointer;

			// margin: 0 10px;
		}

		.menu-list:active {
			border-color: #3a8ee6;
		}

		.menu-list:hover {
			border-color: #c6e2ff;
			color: #409eff;
		}

		.menu-but {
			// width: 4vw;
			border: 1px solid #5d6183;
			border-radius: 5px;
			font-size: 16px;
			color: #e5e5e5;
			padding: 2px 7px;
			display: flex;
			box-shadow: 0 18px 16px rgba(0, 0, 0, 0.6);

			.list-but {
				font-size: 16px;

				span {
					padding: 0 2px;
					cursor: pointer;
				}
			}
		}
	}

	.sp:active {
		border-color: #3a8ee6;
	}

	.sp:hover {
		border-color: #c6e2ff;
		color: #409eff;
	}

	.menu-list1 {
		border-bottom: 1px solid #ffffff;

		// border-color: #c6e2ff;
		color: #409eff !important;
	}

	.zhezhao {
		z-index: 400;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3);
		width: 100vw;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.logoname {
		display: flex;
		align-items: center;
		justify-content: space-around;
		color: #e5e5e5;
		border-radius: 5px;
		background-color: rgba(58, 142, 230, 0.5);
		height: 30px;
		cursor: pointer;
		padding: 0px 10px;
		font-size: 16px;
		border: 1px solid rgba(255, 255, 255, 0.6);
		box-shadow: 0 0.2px 3px rgba(0, 0, 0, 0.6);
		position: relative;


		.longbut1 {


			display: flex;
			justify-content: center;
			align-items: center;
			margin-right: 5px;



		}

		.longbut2 {
			border-left: 1px solid #3a8ee6;
			padding-left: 5px;
			display: flex;
			justify-content: center;
			align-items: center;



		}

		.long-tc {
			position: absolute;
			top: 110%;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 100px;
			height: 90px;
			background-color: #efefef;
			border-radius: 5px;
			box-shadow: 0 18px 16px rgba(0, 0, 0, 0.6);
			display: flex;
			flex-direction: column;
			line-height: 35px;
			align-items: start;
			justify-content: center;
			padding-left: 10px;
			z-index: 400;

			.tc-content {
				display: flex;
				align-items: center;
				justify-content: start;
				font-size: 14px;
				color: #5d6183;

				.tc-img {
					padding-right: 5px;
					width: 20px;
					height: 20px;
				}
			}

			.tc-content:hover {
				color: #0b4cff;

			}

			.st {
				border-bottom: 1px solid #b0b0b0;

			}

			// <div class="tc-content"><img src="../assets/exit.png" class="tc-img" />退出帐号 </div>
		}
	}

	.logoname:hover {
		background-color: #35b9ff;
	}

	.log401 {
		width: 100vw;
		height: 100vh;
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 410;
		display: flex;
		justify-content: center;
		align-items: center;

		.car401 {
			width: 25vw;
			height: 20vh;
			box-shadow: 0 18px 16px rgba(0, 0, 0, 0.6);
			border-radius: 10px;
			background-color: #e5e5e5;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;
			padding-top: 30px;

			.log-title {
				display: flex;
				align-items: center;
				justify-content: space-around;

				.warn {
					width: 40px;
					height: 40px;
				}

				.tishi {
					padding-left: 20px;
					font-size: 20px;
					font-weight: bold;
				}

			}

			// <div class="log-title">
			// 	<img src="../assets/叹号.png" class="warn" /><span class="tishi">登录过期，是否重新登录？</span>
			// </div>
			// <div class="log-title">
			// 	<el-button type="primary">重新登录</el-button>
			// 	<el-button type="warning">放弃登录</el-button>
			// </div>
		}
	}

	.tcedit {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.4);
		z-index: 1000;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.message-container {
		position: relative;
		margin-right: 30px;
	}

	.message-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		width: calc(15px * 15); // 15px汉字20个宽度
		max-height: 50vh;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
		z-index: 500;
		overflow: hidden;
		border: 1px solid #e0e0e0;
		margin-top: 5px;
	}

	.message-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 15px;
		border-bottom: 1px solid #f0f0f0;
		background-color: #f9f9f9;

		span {
			font-weight: bold;
			color: #333;
		}

		.read-all {
			background: none;
			border: none;
			color: #409eff;
			font-size: 14px;
			cursor: pointer;
			padding: 5px;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	.message-list {
		max-height: calc(50vh - 45px); // 减去header高度
		overflow-y: auto;
		padding: 5px 0;
	}

	.message-item {
		display: flex;
		align-items: center;
		padding: 10px 15px;
		cursor: pointer;
		transition: background-color 0.2s;


		&:hover {
			background-color: #f5f7fa;
		}





		.msg-avatar {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			margin-right: 10px;
			flex-shrink: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid rgb(121, 187, 255);
			background-color: rgb(51, 126, 204);
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
			color: #e0e0e0;

			position: relative;
		}

		.msg-avatar1 {
			border: 1px solid rgb(248, 152, 152);
			background-color: #F56C6C;
		}

		.msg-content {
			flex-grow: 1;
			min-width: 0; // 解决文字溢出问题

			.msg-sender {
				font-size: 14px;
				color: #333;
				margin-bottom: 3px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				text-align: left;
			}

			.msg-text {
				font-size: 13px;
				color: #666;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.msg-time {
			font-size: 12px;
			color: #999;
			margin-left: 10px;
			flex-shrink: 0;
		}
	}

	.empty-message {
		text-align: center;
		padding: 30px 0;
		color: #999;
		font-size: 14px;
	}

	.longbut0 {
		position: relative;
		/* 父容器相对定位，用于红点绝对定位 */
		// padding-right: 18px;
		/* 给红点预留空间，避免文字与红点重叠 */
		cursor: pointer;
		transition: background-color 0.2s ease;
		/*  hover过渡更丝滑 */

		&:hover {
			background-color: #35b9ff;
		}

		/* 新的未读红点样式 */
		.unread-dot {
			/* 1. 基础圆形样式 */
			position: absolute;
			top: -12px;
			/* 垂直位置：靠近文字顶部，避免偏上/偏下 */
			right: -15px;
			/* 水平位置：父容器最右侧 */
			width: 10px;
			/* 红点大小（适中，不突兀） */
			height: 10px;
			border-radius: 50%;
			/* 圆形 */
			background-color: #F56C6C;
			/* 红色：Element UI危险色，符合未读通知视觉习惯 */
			box-shadow: 0 0 3px rgba(245, 108, 108, 0.8);
			/* 轻微阴影，增强立体感 */
			border: 2px solid #fff;
			/* 白色边框，与背景区分开，避免融入父容器 */
		}
	}

	.chat-main {
		width: 100vw;
		height: 100vh;
		position: relative;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		// background-color: rgba(0, 0, 0, 0.3);
		// display: flex;
		// justify-content: center;
		// align-items: center;
		z-index: 500;
		// overflow: hidden;
	}

	.tishi {
		// padding-left: 20px;
		font-size: 16px;
		font-weight: bold;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.ewm {
		position: absolute;
		top: 9vh;
		left: 50px;
		z-index: 900;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		padding: 10px;
		border-radius: 10px;


		.text {
			font-size: 13.5px;
			font-weight: 900;
		}


	}
</style>